import React from 'react';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import MenuItem from '@material-ui/core/MenuItem';
import MenuList from '@material-ui/core/MenuList';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import IconButton from "@material-ui/core/IconButton";
import MoreIcon from '../../icons/MoreIcon';
import Avatar from '@material-ui/core/Avatar';
import ListItemText from "@material-ui/core/ListItemText";
import icons_bn from '../../other/icons_bn.json';

const useStyles = makeStyles((theme) => ({
	root: {
		display: 'flex',
	},
	paper: {
		marginRight: theme.spacing(2),
	},
}));

const StyledMenuItem = withStyles((theme) => ({
	root: {
		paddingTop: 12,
		paddingBottom: 12,
		minWidth: 293,
		color: "#FFFFFF",
		// "&:focus": {
		//backgroundColor: theme.palette.primary.main,
		// "& .MuiListItemIcon-root, & .MuiListItemText-primary": {
		"& .MuiListItemText-primary": {
			// width: 213,
			fontFamily: 'Cera CY',
			fontStyle: 'normal',
			fontWeight: 'normal',
			fontSize: '16px',
			lineHeight: '24px',
			color: '#24262A',
			marginLeft: 16
		}
		// }
	}
}))(MenuItem);

const StyledAvatar = withStyles((theme) => ({
	root: {
		width: 48,
		height: 48,
		borderRadius: 16
	}
}))(Avatar);

export default function MenuListComposition(props) {
	const classes = useStyles();
	const [open, setOpen] = React.useState(false);
	const anchorRef = React.useRef(null);
	let { BusinessDirectionAdditional } = props;

	const handleClick = (event) => {
		setOpen((prevOpen) => !prevOpen);
	};

	const handleClose = (event) => {
		if (anchorRef.current && anchorRef.current.contains(event.target)) {
			return;
		}

		setOpen(false);
	};

	function handleListKeyDown(event) {
		if (event.key === 'Tab') {
			event.preventDefault();
			setOpen(false);
		}
	}

	// return focus to the button when we transitioned from !open -> open
	const prevOpen = React.useRef(open);
	React.useEffect(() => {
		if (prevOpen.current === true && open === false) {
			anchorRef.current.focus();
		}

		prevOpen.current = open;
	}, [open]);

	return (
		<div className={classes.root}>
			<IconButton aria-label="more" ref={anchorRef}
				aria-controls={open ? 'menu-list-grow' : undefined}
				aria-haspopup="true" size="small" onClick={(e) => handleClick(e)}>
				<MoreIcon fill='#BCBBD0' />
			</IconButton>

			<Popper open={open} anchorEl={anchorRef.current} role={undefined} transition disablePortal placement={'right-start'}>
				{({ TransitionProps, placement }) => (
					<Grow
						{...TransitionProps}
						style={{ transformOrigin: placement === 'bottom' ? 'left bottom' : 'left top' }}
					>
						<Paper style={{
							maxHeight: 416, boxShadow: '4px 4px 30px rgba(35, 72, 152, 0.2)',
							borderRadius: '16px',
							paddingTop: '8px',
							paddingBottom: '8px', overflow: 'auto'
						}}>
							<ClickAwayListener onClickAway={handleClose}>
								<MenuList autoFocusItem={open} id="menu-list-grow" onKeyDown={handleListKeyDown}>
									{BusinessDirectionAdditional.length > 0 ? BusinessDirectionAdditional.split('#;').map(elem => {
										let elemM = elem.split('@;')

										return (
											<a href={`/applications/${elemM[3]}/applist?filt=false&direction=${elemM[0]}`} style={{ textDecoration: 'none' }}>
												<StyledMenuItem /* onClick={() => alert('CLICK!')} */>
													<StyledAvatar
														aria-label="recipe"
														className={classes.avatar}
														style={{ backgroundColor: elemM[2] && elemM[2].length > 5 ? `#${elemM[2]}` : '#E45670', padding: 8 }}
														src={icons_bn[`${elemM[0]}`]}
													/>
													<ListItemText style={{ maxWidth: 200, whiteSpace: 'break-spaces' }} primary={elemM[1]} />
												</StyledMenuItem>
											</a>
										)
									})
										:
										''
									}
								</MenuList>
							</ClickAwayListener>
						</Paper>
					</Grow>
				)}
			</Popper>
		</div>
	);
}